module.exports = __webpack_public_path__ + "static/img/mba-flow.9b5a3b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personRain/mba-flow.png
// module id = 3G8q
// module chunks = 2